import { render } from "./Income.vue?vue&type=template&id=5fbabaa2&scoped=true"
import script from "./Income.vue?vue&type=script&lang=js"
export * from "./Income.vue?vue&type=script&lang=js"

import "./Income.vue?vue&type=style&index=0&id=5fbabaa2&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbabaa2"]])

export default __exports__